<template lang="html">
  <div class="slds-size_1-of-1 slds-box slds-grid">


    <!-- Select tipo
    <div class="slds-form-element">
      <label class="slds-form-element__label" for="select-tipo"><abbr class="slds-required" title="Richiesto">* </abbr>Tipo di assegno</label>
      <div class="slds-form-element__control">
        <div class="slds-select_container">
          <select class="slds-select" id="select-tipo">
            <option value="">Selezionare il tipo di assegno</option>
            <option value="AC">AC - Assegno circolare</option>
            <option value="AB">AB - Assegno bancario</option>
            <option value="CC">CC - Contanti</option>
            <option value="EF">EF - Effetti</option>
          </select>
        </div>
      </div>
    </div>
     Fine select tipo -->
    <!-- Input banca
    <div class="slds-form-element">
      <label class="slds-form-element__label" for="input-banca">
        <abbr class="slds-required" title="Richiesto">* </abbr>Descrizione banca</label>
      <div class="slds-form-element__control">
        <input type="text" id="input-banca" placeholder="Inserire il nome della banca" required="" class="slds-input" />
      </div>
    </div>
    Fine input banca -->

    <!-- Icona foto -->
    <div class="slds-size_1-of-12 slds-col slds-align_absolute-center slds-grid slds-grid_vertical nogutter">
      <div :id="'input-lab-1-'+assegno.id" class="slds-col slds-size_1-of-1"></div>
      <div class="slds-col slds-size_1-of-1">
        <button class="slds-button slds-button_icon" title="Aggiungi foto" v-on:click="$emit('calledCamera')">
          <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#photo"></use>
          </svg>
          <span class="slds-assistive-text">Aggiungi foto</span>
        </button>
      </div>
    </div>
    <!-- Icona ci sono foto -->
    <div class="slds-size_1-of-12 slds-col slds-align_absolute-center slds-grid slds-grid_vertical nogutter">
      <div :id="'input-lab-2-'+assegno.id" class="slds-col slds-size_1-of-1"></div>
      <div class="slds-col slds-size_1-of-1">
        <span class="slds-icon_container slds-icon-utility-image" :title="(assegno.photos.length>0?'Ci sono '+assegno.photos.length+' foto per questo assegno':'Questo assegno non ha foto')" v-on:click="$emit('calledCamera')">
          <svg class="slds-icon" :class="'slds-icon-text-'+(assegno.photos.length>0?'success':'light')" aria-hidden="true">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#image"></use>
          </svg>
          <span class="slds-assistive-text">{{(assegno.photos.length>0?'Ci sono '+assegno.photos.length+' foto per questo assegno':'Questo assegno non ha foto')}}</span>
        </span>
      </div>
    </div>
    <!-- Input data -->
    <div class="slds-form-element slds-col slds-size_1-of-4 slds-grid slds-grid_vertical nogutter">
      <div :id="'input-lab-3-'+assegno.id" class="slds-col slds-size_1-of-1">
        <label class="slds-form-element__label" for="input-data">
          Data dell'assegno
        </label>
      </div>
      <div class=" slds-col slds-size_1-of-1">
        <div class="slds-form-element__control">
          <vueDate id="input-data" :value="assegno.data" @input="(value)=>assegno.data=value" class="slds-input" :readonly="readonly"/>
        </div>
      </div>
    </div>
    <!-- Fine input data -->
    <!-- Input numero -->
    <div class="slds-form-element slds-col slds-size_1-of-4 slds-grid slds-grid_vertical nogutter">
      <div :id="'input-lab-big-'+assegno.id" class="slds-col slds-size_1-of-1">
        <label class="slds-form-element__label" for="input-numero">
          Numero dell'assegno
        </label>
      </div>
      <div class="slds-col slds-size_1-of-1">
        <div class="slds-form-element__control">
          <input type="text" id="input-numero" v-model="assegno.numero" placeholder="Numero dell'assegno" class="slds-input" :readonly="readonly" />
        </div>
      </div>
    </div>
    <!-- Fine input numero -->
    <!-- Input cifra -->
    <div class="slds-form-element slds-col slds-size_1-of-4 slds-grid slds-grid_vertical nogutter">
      <div :id="'input-lab-4-'+assegno.id" class="slds-col slds-size_1-of-1">
        <label class="slds-form-element__label" for="input-cifra">
          Cifra incassata
        </label>
      </div>
      <div class="slds-col slds-size_1-of-1">
        <div class="slds-form-element__control">
          <input type="number" id="input-cifra" v-model="assegno.cifra" placeholder="Cifra incassata" class="slds-input" :readonly="readonly"/>
        </div>
      </div>
    </div>
    <!-- Fine input cifra -->
    <!-- Icona elimina -->
    <div class="slds-size_1-of-12 slds-col slds-align_absolute-center slds-grid slds-grid_vertical nogutter">
      <div :id="'input-lab-5-'+assegno.id" class="slds-col slds-size_1-of-1"></div>
      <div class="slds-col slds-size_1-of-1">
        <button class="slds-button slds-button_icon" title="Elimina assegno" v-on:click="deleting=true" :disabled="readonly">
          <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
          </svg>
          <span class="slds-assistive-text">Elimina assegno</span>
        </button>
      </div>
    </div>

    <!-- Textarea comunicazioni
    <div class="slds-form-element">
      <label class="slds-form-element__label" for="textarea-comunicazioni">Comunicazioni</label>
      <div class="slds-form-element__control">
        <textarea id="textarea-comunicazioni" class="slds-textarea" placeholder="Inserisci qui le note aggiuntive" v-model="assegno.comunicazioni"></textarea>
      </div>
    </div>
    Fine textarea comunicazioni -->
    <!--<button type="button" name="button" v-on:click="debug">debug</button>-->

    <div v-if="deleting">
      <section role="dialog" tabindex="-1" aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1" class="slds-modal slds-fade-in-open" style="z-index:10001">
        <div class="slds-modal__container">
          <header class="slds-modal__header">
            <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Chiudi" v-on:click="deleting=false">
              <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
              </svg>
              <span class="slds-assistive-text">Chiudi</span>
            </button>
            <h2 id="modal-heading-01" class="slds-modal__title slds-hyphenate">Sicuro di voler eliminare questo assegno con tutte le sue foto?</h2>
          </header>
          <footer class="slds-modal__footer slds-modal__footer_directional">
            <button class="slds-button slds-button_destructive" v-on:click="functionDelete">Elimina</button>
            <button class="slds-button slds-button_neutral" v-on:click="deleting=false">Annulla</button>
          </footer>
        </div>
      </section>
      <div class="slds-backdrop slds-backdrop_open" style="z-index:10000"></div>
    </div>
  </div>
</template>

<script>
import vueDate from './vueDate.vue';

export default {
  name: 'Assegno',
  components: {
    vueDate
  },
  data: () => ({
    deleting: false
  }),
  props: {
    assegno: Object,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    functionDelete: function() {
      this.deleting = false;
      this.$emit('deletedAssegno');
    },
    onResize: function() {
      var height = document.getElementById('input-lab-big-' + this.assegno.id).offsetHeight;
      document.getElementById('input-lab-1-' + this.assegno.id).style.height = height + "px";
      document.getElementById('input-lab-2-' + this.assegno.id).style.height = height + "px";
      document.getElementById('input-lab-3-' + this.assegno.id).style.height = height + "px";
      document.getElementById('input-lab-4-' + this.assegno.id).style.height = height + "px";
      document.getElementById('input-lab-5-' + this.assegno.id).style.height = height + "px";
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="css" scoped>
  input{
    font-size: .8rem;
  }
</style>
